import { render, staticRenderFns } from "./SortInputGroup.vue?vue&type=template&id=495e77e0"
import script from "./SortInputGroup.vue?vue&type=script&lang=js"
export * from "./SortInputGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports